'use strict';

angular.module('cgmemApp')
	.controller('AdminSysLogCtrl', function ($rootScope, $scope, $http, $log) {

		$scope.levels = ["silly", "debug", "verbose", "info", "warn", "error"];
		$scope.level = "warn";

		$scope.itemCountOpts = [{ label: "10/page", count: 10 }, { label: "20/page", count: 20 },
								{ label: "100/page", count: 100 }, { label: "1000/page", count: 1000 }];

		//$scope.itemFilterOpts = [{ label: "Exceptions", val: false }, { label: "All", val: true }];

		$scope.currentPage = 1;
		$scope.pageSize = 20;

		var syslog = [];
		$scope.filtered = $scope.paged = [];
		$scope.epoch = null;
		
		$scope.$watchGroup(['currentPage', 'pageSize', 'level', 'epoch'], function () {
			var start = ($scope.currentPage - 1) * $scope.pageSize;
			$scope.filtered = _.filter(syslog, function(c) {
				return $scope.levels.indexOf(c.level) >= $scope.levels.indexOf($scope.level);
			});
			//$scope.filtered = syslog;
			$scope.paged = _.slice($scope.filtered, start, start + $scope.pageSize);
		});

		var getSysLog = function() {
			$http.get('/api/syslog', {params: {n:10000}})
				.then(function (r) {
					syslog = _.orderBy(r.data, 'created', 'desc');
					$scope.epoch = new Date();
				})
				.catch(function(err) {
					$rootScope.$emit('generalAlert', 'Error getting syslog: ' + err);
				});
		};


		$scope.$on('socket:syslog', function(ev, m) {
			getSysLog();
		});
		getSysLog();

	});
